<template>
    <div class="wrap">
        <div class="notice-item">
            <div class="notice-con">
                <h1>{{ articleInfo.title }}</h1>
                <div class="desc">发表于{{ articleInfo.create_time }}</div>
                <div class="notice-con-detail" v-html="articleInfo.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { getArticleDetails } from '@api/public';

export default {
    name: 'NewsDetail',
    components: {},
    props: {},
    data: function() {
        return {
            articleInfo: {},
            storeInfo: {},
            shareInfoStatus: false
        };
    },
    watch: {
        $route(to) {
            if (to.name === 'NewsDetail') this.articleDetails();
        }
    },
    mounted: function() {
        this.articleDetails();
    },
    methods: {
        updateTitle() {
            document.title = this.articleInfo.title || this.$route.meta.title;
        },
        articleDetails: function() {
            let that = this,
                id = this.$route.params.id;
            getArticleDetails(id).then(res => {
                that.articleInfo = res.data;
                that.updateTitle();
            });
        }
    }
};
</script>
